import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SnackBarType } from '../../../../app/core/types/enums';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [CommonModule, MatIconModule],
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { type: string; message: string }
  ) {}

  get isSuccess() {
    if (this.data) {
      return this.data.type === SnackBarType.SUCCESS;
    }
    return false;
  }
}
